import { SUPPORTED_SEGMENT_TYPES } from '../constants/segments';
export const isSupportedSegmentType = segmentType => SUPPORTED_SEGMENT_TYPES.includes(segmentType);